// path: luul/client/src/redux/middleware/friendSocketMiddleware.js
import { io } from 'socket.io-client';
import { SET_CURRENT_USER, LOGOUT } from '../actions/actionTypes';
import { updateFriendStatus, setFriendsList } from '../actions/socialActions';

const friendSocketMiddleware = () => {
  let socket = null;

  return (store) => (next) => (action) => {
    // 1. Initialize when user is set
    if (action.type === SET_CURRENT_USER && action.payload?.id) {
      if (!socket) {
        socket = io(`${process.env.REACT_APP_BACKEND_URL}/friends`, {
          query: { userId: action.payload.id },
          transports: ['websocket'],
        });

        // 2. Listen for new friends (Real-time update)
        socket.on('new-friend-added', (newFriend) => {
          const { friends } = store.getState().social;

          // Check if friend already exists in state to avoid duplicates
          const alreadyExists = friends.some((f) => f.id === newFriend.id);

          if (!alreadyExists) {
            // Append new friend to existing list and dispatch
            store.dispatch(setFriendsList([...friends, newFriend]));
          }
        });

        // 3. Listen for status changes (Studying, Free, etc.)
        socket.on('friend-status-changed', (data) => {
          // data: { friendId, status }
          store.dispatch(updateFriendStatus(data.friendId, data.status));
        });
      }
    }

    // 4. Cleanup on Logout
    if (action.type === LOGOUT) {
      if (socket) {
        socket.disconnect();
        socket = null;
      }
    }

    return next(action);
  };
};

export default friendSocketMiddleware;
